export const WIDGET_HEIGHT_IN_PX = 90;
export const WIDGET_WIDTH_IN_PX = 160;
export const DASHBOARD_COLUMN_COUNT = 30;
export const DASHBOARD_ROW_COUNT = 30;
